import { render, staticRenderFns } from "./p-side-info-bar.vue?vue&type=template&id=691141ae&"
import script from "./p-side-info-bar.vue?vue&type=script&lang=js&"
export * from "./p-side-info-bar.vue?vue&type=script&lang=js&"
import style0 from "./p-side-info-bar.vue?vue&type=style&index=0&id=691141ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports